let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jqTTu")).then(() => parcelRequire('g8hh0'));